export const user_addresses = `{
    id
    title
    address
    is_default
    location
    mobile
    user_name
    user_last_name
    postal_code
    has_receiver_details
    city_id
    city {
      id
      name
      native
    }
    state_id
    state {
      id
      name
      native
    }
    country{
      id
      name
      native
    }
}`

export const user_address_in_checkout = `{
  id
  title
  address
  is_default
  location
  mobile
  user_name
  user_last_name
  postal_code
  city {
    name
    native
  }
  state {
    name
    native
  }
  country{
    name
    native
  }
}`